export default __webpack_public_path__ + "locales/de/ChangeUserTypeDialog.json?hash=d444bb0452beb3d628e87ca9cdd7f8d4";